export default __webpack_public_path__ + "static/formula-366a27b1a5f46c1137fbbee711bae4d9.webp";